import Vue from 'vue'
import { PageNotFound } from 'kuaidong-component'
import VueRouter, { Route, RouteConfig } from 'vue-router'

import RLongBreak from './RLongBreak'
import RTest, * as testRouter from './RTest'
import RRank, * as rankRouter from './RRank'
import RAuth, * as authRouter from './RAuth'
import RExam, * as examRouter from './RExam'
import RExamUniversity, * as examUniversityRouter from './RExamUniversity'
import RClazz, * as clazzRouter from './RClazz'
import RAbout, * as aboutRouter from './RAbout'
import RSchool, * as schoolRouter from './RSchool'
import RLayout, * as layoutRouter from './RLayout'
import RNotice, * as noticeRouter from './RNotice'
import RSummer, * as summerRouter from './RSummer'
import RTeacher, * as teacherRouter from './RTeacher'
import RSupport, * as supportRouter from './RSupport'
import RAddress, * as addressRouter from './RAddress'
import RMoreApp, * as moreAppRouter from './RMoreApp'
import RRPETest, * as rpeTestRouter from './RRPETest'
import RHomework, * as homeworkRouter from './RHomework'
import RActivity, * as activityRouter from './RActivity'
import RClazzMgt, * as clazzMgtRouter from './RClazzMgt'
import RExemption, * as exemptionRouter from './RExemption'
import RClazzJoin, * as clazzJoinRouter from './RClazzJoin'
import RGymnastics, * as gymnasticsRouter from './RGymnastics'
import RLessonPlan, * as lessonPlanRouter from './RLessonPlan'
import RExamRecord, * as examRecordRouter from './RExamRecord'
import RCourseLive, * as courseLiveRouter from './RCourseLive'
import RSummer2022, * as summer2022Router from './RSummer2022'
import RWinter2023, * as winter2023Router from './RWinter2023'
import RAIAssistant, * as aiAssistantRouter from './RAIAssistant'
import RAiTeacher, * as aiTeacherRouter from './RAiTeacher'
import RAiChat, * as aiChatRouter from './RAiChat'
import RAiTest, * as aiTestRouter from './RAiTest'
import RSportsAnalyze, * as sportsAnalyzeRouter from './RSportsAnalyze'
import RNormalActivity, * as normalActivityRouter from './RNormalActivity'

import RSchoolMgt, * as schoolMgtRouter from './RSchoolMgt'
import RCompetition, * as competitionRouter from './RCompetition'
import RCertificate, * as certificateRouter from './RCertificate'
import ROnlineCourse, * as onlineCourseRouter from './ROnlineCourse'
import RStudentAuthMgt, * as studentAuthMgtRouter from './RStudentAuthMgt'
import RCompetitionArea, * as competitionAreaRouter from './RCompetitionArea'
import RJumpropeIntelligent, * as jumpropeIntelligentRouter from './RJumpropeIntelligent'

import RDrillReport, * as drillReportRouter from './RDrillReport'
import RMovePractice, * as movePracticeRouter from './RMovePractice'
import RPracticePlan, * as practicePlanRouter from './RPracticePlan'
import RInviteTeacher, * as inviteTeacherRouter from './RInviteTeacher'
import RClassroomQuiz, * as classroomQuizRouter from './RClassroomQuiz'
import RHomeworkReport, * as homeworkReportRouter from './RHomeworkReport'
import RVacationHomework, * as vacationHomworkRouter from './RVacationHomework'
import RBroadcastGymnastics, * as broadcastGymnasticsRouter from './RBroadcastGymnastics'
import RExercisePrescription, * as exercisePrescriptionRouter from './RExercisePrescription'
import REastChinaNormalUniversity, * as eastChinaNormalUniversityRouter from './REastChinaNormalUniversity'
import RExercisePrescriptionReport, * as exercisePrescriptionReportRouter from './RExercisePrescriptionReport'
import RSchoolManage, * as schoolManageRouter from './RSchoolManage'
import RAutumn2022, * as autumn2022Router from './RAutumn2022'
import RFamousTeacher, * as famousTeacherRouter from './RFamousTeacher'
import RFamousTeacherStudio, * as famousTeacherStudioRouter from './RFamousTeacherStudio'
import RLecture, * as lectureRouter from './RLecture'
import ROnlineSportsMeeting, * as onlineSportsMeetingRouter from './RSportsMeeting'
import RExamEnterProcess, * as examEnterProcessRouter from './RExamEnterProcess'
import RApprovalLeave, * as approvalLeaveRouter from './RApprovalLeave'
import RMyGift, * as myGiftRouter from './RMyGift'
import RPEClass, * as peClassRouter from './RPEClass'
import RPEPointsSystem, * as pePointsRouter from './RPEPointsSystem'
import RPEClassBigBreak, * as peClassBigBreakRouter from './RPEClassBigRecess'
import RCourseCenter, * as courseCenterRouter from './RCourseCenter'
import RRunTask, * as runTaskRouter from './RRunTask'
import RProcessEvaluation, * as processEvaluationRouter from './RProcessEvaluation'
import RDrill, * as drillRouter from './RDrill'
import RComment, * as commentRouter from './RComment'
import RPEHomework, * as peHomeworkRouter from './RPEHomework'
import RAfterSchoolTranning, * as afterSchoolTranningRouter from './RAfterSchoolTranning'
import RLanding, * as landingRouter from './RLanding'
import RSousouEntry, * as sousouEntryRouter from './RSousouEntry'
import ROneHourRoutes, * as oneHourEntryRouter from './ROneHour'
import RPrizeRecord, * as prizeRecordRouter from './RPrizeRecord'
import RJumpropeDevicePreview, * as jumpropeDevicePreviewRouter from './RJumpropeDevicePreview'
import RIntelligentClassroom, * as intelligentClassroomRouter from './RIntelligentClassroom'
import RAcademyMgt, * as academyMgtRouter from './RAcademyMgt'
import RDynamicPage, * as dynamicPageRouter from './RDynamicPage'
import ROfficialNotice, * as officialNoticeRouter from './ROfficialNotice'
import RClassRoom from './RClassRoom'
import RMovementCompare, * as movementCompareRouter from './RMovementCompare'

import {
  RAd,
  RLeads,
  RFission,
  RExam2023,
  RFissionS3,
  RGymnastic,
  RLogistics,
  RSportsTrail,
  RSemesterReport,
  RMarketingMatchHeld,
  RWinterVacation2023,
  RLessonPlanCollection,
  RJumpropeRefereeTraining,
  RWinterVacation2023Excellent,
  RNewTermPlan202402,
  RNewTermPlan202502,
  RWorkContest202403,
  RCommonSharePage,
  RSummerVacation2024HomeworkTea,
  RSeniorHighSchoolEntranceExam,
  RWinter2023ExcellenceSelection,
  RActivityTeacher2024,
  RSummerVacation2025Homework,
  RNewSemester2025,

  // routers
  adRouter,
  leadsRouter,
  fissionRouter,
  exam2023Router,
  fissionS3Router,
  gymnasticRouter,
  logisticsRouter,
  sportsTrailRouter,
  winterVacationRouter2023,
  winterVacationRouter2024,
  winterVacationRouter2025,
  lessonPlanCollectionRouter,
  jumpropeRefereeTrainingRouter,
  winterVacationRouter2023Excellent,
  seniorHighSchoolEntranceExamRouter,
  winter2023ExcellenceSelectionRouter,
  workContestRouter202403,
  commonSharePageRouter,
  summerVacationRouter2024HomeworkTea,
  RWinterVacation2024,
  RWinterVacation2025,
} from 'kuaidong-activity'

import RTzyUniversityTeacher, { routers as tzyUniversityTeacherRouters } from 'tzy-university-teacher'
import { Position } from 'vue-router/types/router'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  RLayout, // 布局
  RTzyUniversityTeacher, // 体智云大学版

  ...RRank, // 排行榜
  ...RAuth, // 认证
  ...RExam, // 体测
  ...RExamUniversity, //大学版体测
  ...RClazz, // 班级
  ...RAbout, // 功能介绍
  ...RSchool, // 学校
  ...RNotice, // 消息中心
  ...RSummer, // 暑假作业
  ...RTeacher, // 教师管理
  ...RSupport, // 支持相关
  ...RAddress, // 地址
  ...RMoreApp, // 更多app
  ...RRPETest, // RPE测评
  ...RHomework, // 作业
  ...RActivity, // 活动
  ...RClazzMgt, // 班级管理
  ...RLongBreak, // 大课间
  ...RExemption, // 免修
  ...RClazzJoin, //创建班级
  ...RSchoolMgt, // 学校管理
  ...RGymnastics, // 广播体操检查作业
  ...RLessonPlan, // 教案
  ...RExamRecord, // 体测录入
  ...RCourseLive, // 在线课
  ...RSummer2022, // 暑假作业2022
  ...RCompetition, // 比赛
  ...RCertificate, // 证书
  ...RDrillReport, // 报告
  ...RAIAssistant, // AI助手
  ...RAiTeacher, // AI教师
  ...RAiChat, // AI聊天
  ...RAiTest, // AI体测
  ...RMovePractice, // 回家练
  ...RPracticePlan, // 体测练习
  ...ROnlineCourse, // 在线课
  ...RInviteTeacher, // 邀请老师
  ...RClassroomQuiz, // 随堂测
  ...RHomeworkReport, // 作业通知
  ...RStudentAuthMgt, // 学生认证管理
  ...RCompetitionArea, // 省市级比赛
  ...RVacationHomework, // 假期作业
  ...RBroadcastGymnastics, // 广播体操
  ...RJumpropeIntelligent, // 智能跳绳
  ...RExercisePrescription, // 运动处方
  ...REastChinaNormalUniversity, // 华东师范大学
  ...RExercisePrescriptionReport, // 运动处方周报
  ...RSchoolManage, // 学校管理初始化
  ...RAutumn2022, // 新学期作业2022
  ...RFamousTeacher, // 名师讲堂
  ...RFamousTeacherStudio, // 名师工作室
  ...RLecture,
  ...ROnlineSportsMeeting, //运动会
  ...RExamEnterProcess, //体测录入
  ...RApprovalLeave, // 请假审批
  ...RWinter2023,
  ...RNormalActivity, // 通用活动
  ...RMyGift,
  ...RPEClass, // 体育课评价
  ...RPEClassBigBreak, // 大课间
  ...RPEPointsSystem, // 积分系统
  ...RCourseCenter, //商城中心
  ...RRunTask, // 跑步任务
  ...RProcessEvaluation, // 过程性评价
  ...RDrill, // drill 相关功能页
  ...RComment, // 评论
  ...RPEHomework, // 体育作业
  ...RAfterSchoolTranning, // 课后训练
  ...RLanding,
  ...RSousouEntry, // 嗖嗖报名
  ...RPrizeRecord, // 奖品记录
  ...ROneHourRoutes, //校外一小时
  ...RJumpropeDevicePreview, // 跳绳硬件预告
  ...RIntelligentClassroom, // 智慧课堂
  ...RAcademyMgt, // 学院管理
  ...RDynamicPage, // 运营动态配置页面
  ...ROfficialNotice, // 教育局官方通知
  ...RClassRoom, // 随堂测试
  ...RMovementCompare, // 运动姿态检测分析
  ...RSportsAnalyze, // 运动姿态分析
  // activity
  ...RAd,
  ...RLeads,
  ...RFission,
  ...RExam2023,
  ...RFissionS3,
  ...RGymnastic,
  ...RLogistics,
  ...RSportsTrail,
  ...RSemesterReport,
  ...RMarketingMatchHeld,
  ...RWinterVacation2023,
  ...RWinterVacation2024,
  ...RWinterVacation2025,
  ...RLessonPlanCollection,
  ...RJumpropeRefereeTraining,
  ...RWinterVacation2023Excellent,
  ...RNewTermPlan202402,
  ...RNewTermPlan202502,
  ...RWorkContest202403,
  ...RCommonSharePage,
  ...RSummerVacation2024HomeworkTea,
  ...RSeniorHighSchoolEntranceExam,
  ...RWinter2023ExcellenceSelection,
  ...RActivityTeacher2024,
  ...RSummerVacation2025Homework,
  ...RNewSemester2025, // 2025新学期

  // 测试用的路由
  ...RTest,

  // page not found.
  {
    path: '/:pathMatch(.*)*',
    name: 'page_not_found',
    component: PageNotFound,
    meta: {
      title: '体智云',
    },
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior: (to: Route, from: Route, savedPosition: Position | void) => {
    // https://router.vuejs.org/guide/advanced/scroll-behavior
    return savedPosition ? savedPosition : ({ top: 0 } as any)
  },
})

export default router

export const ignoreLoginRoutes = [
  testRouter.testRoute,
  testRouter.testKdUiRoute,

  aboutRouter.aboutSaasRoute,
  aboutRouter.aboutExamRoute,
  aboutRouter.aboutCompetitionRoute,
  aboutRouter.aboutMovePracticeRoute,
  aboutRouter.aboutClazzroomQuizRoute,
  aboutRouter.aboutContactUsRoute,

  adRouter.adRoute,
  adRouter.adPCRoute,
  authRouter.authRoute,
  authRouter.authFormRoute,
  authRouter.adAuthFormRoute,
  authRouter.qrCodeLoginRoute,
  authRouter.accountLoginRoute,
  authRouter.authSchoolSelectRoute,

  leadsRouter.leadsRoute,
  lessonPlanRouter.detailRoute,
  summer2022Router.landingRoute,
  gymnasticRouter.gymnasticsRoute,
  winterVacationRouter2023.indexRoute,
  winterVacationRouter2024.indexRoute,
  winterVacationRouter2025.indexRoute,
  winterVacationRouter2023Excellent.indexRoute,
  drillReportRouter.drillReportRoute,
  activityRouter.springTermActivityRoute,
  supportRouter.supportDownloadMaterialRoute,
  activityRouter.winterVacationActivityRoute,
  eastChinaNormalUniversityRouter.eastChinaNormalUniversityRoute,
  eastChinaNormalUniversityRouter.landingPageNewSemesterPageRoute,
  autumn2022Router.preHeatRoute,
  autumn2022Router.preHeatRulesRoute,
  famousTeacherRouter.famousTeacherDetailRouter,
  famousTeacherRouter.famousTeacherListRouter,
  famousTeacherRouter.famousTeacherShareRouter,
  sportsTrailRouter.notifyRoute,
  winter2023Router.deliveryAddressEditRoute,
  winter2023Router.activePageRoute,
  winter2023ExcellenceSelectionRouter.indexRoute,
  normalActivityRouter.spring2023LandingRoute,
  normalActivityRouter.winter2023LandingRoute,
  landingRouter.broadcastLandingRoute,
  landingRouter.iscLandingRoute,
  workContestRouter202403.indexRoute,
  workContestRouter202403.nameListRoute,
  dynamicPageRouter.indexRoute,
]

export const ignoreLoginInBrowserRoutes = [fissionRouter.fissionActivityInvitationRoute]

export const ignoreAuthRoutes = [
  adRouter.adRoute,
  adRouter.adPCRoute,
  lessonPlanRouter.detailRoute,
  inviteTeacherRouter.inviteTeacherRoute,
  supportRouter.supportDownloadMaterialRoute,
  fissionRouter.fissionActivityInvitationRoute,
  inviteTeacherRouter.inviteTeacherFeedBackRoute,
  winter2023ExcellenceSelectionRouter.indexRoute,
  drillRouter.startDrillRoute,
]

export {
  rankRouter,
  authRouter,
  examRouter,
  examUniversityRouter,
  clazzRouter,
  aboutRouter,
  schoolRouter,
  layoutRouter,
  noticeRouter,
  summerRouter,
  teacherRouter,
  supportRouter,
  addressRouter,
  moreAppRouter,
  rpeTestRouter,
  homeworkRouter,
  activityRouter,
  clazzMgtRouter,
  exemptionRouter,
  clazzJoinRouter,
  schoolMgtRouter,
  gymnasticsRouter,
  lessonPlanRouter,
  examRecordRouter,
  courseLiveRouter,
  summer2022Router,
  competitionRouter,
  certificateRouter,
  drillReportRouter,
  aiAssistantRouter,
  aiTeacherRouter,
  aiChatRouter,
  aiTestRouter,
  movePracticeRouter,
  practicePlanRouter,
  onlineCourseRouter,
  inviteTeacherRouter,
  classroomQuizRouter,
  homeworkReportRouter,
  studentAuthMgtRouter,
  vacationHomworkRouter,
  competitionAreaRouter,
  broadcastGymnasticsRouter,
  jumpropeIntelligentRouter,
  exercisePrescriptionRouter,
  eastChinaNormalUniversityRouter,
  exercisePrescriptionReportRouter,
  schoolManageRouter,
  autumn2022Router,
  famousTeacherRouter,
  famousTeacherStudioRouter,
  lectureRouter,
  onlineSportsMeetingRouter,
  examEnterProcessRouter,
  approvalLeaveRouter,
  winter2023Router,
  normalActivityRouter,
  myGiftRouter,
  peClassRouter,
  pePointsRouter,
  peClassBigBreakRouter,
  courseCenterRouter,
  runTaskRouter,
  processEvaluationRouter,
  drillRouter,
  commentRouter,
  peHomeworkRouter,
  tzyUniversityTeacherRouters,
  afterSchoolTranningRouter,
  sousouEntryRouter,
  jumpropeDevicePreviewRouter,
  intelligentClassroomRouter,
  academyMgtRouter,
  dynamicPageRouter,
  officialNoticeRouter,
  movementCompareRouter,
  // activity
  adRouter,
  fissionRouter,
  exam2023Router,
  fissionS3Router,
  gymnasticRouter,
  logisticsRouter,
  winterVacationRouter2023,
  winterVacationRouter2024,
  winterVacationRouter2025,
  winterVacationRouter2023Excellent,
  lessonPlanCollectionRouter,
  jumpropeRefereeTrainingRouter,
  seniorHighSchoolEntranceExamRouter,
  winter2023ExcellenceSelectionRouter,
  workContestRouter202403,
  commonSharePageRouter,
  summerVacationRouter2024HomeworkTea,
  oneHourEntryRouter,
  prizeRecordRouter,
}
